import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

const RED = "#c00000";
const O = { fontFamily: "Outfit, sans-serif" };
const TECH = "https://images.unsplash.com/photo-1484557052118-f32bd25b45b5?w=1600&q=80";

export function PageHero({ eyebrow, title, highlight, subtitle }) {
  return (
    <section className="relative overflow-hidden bg-[#0f1115]">
      <div aria-hidden className="absolute inset-0">
        <img src={TECH} alt="" className="w-full h-full object-cover" style={{ filter: "grayscale(1) blur(6px) brightness(0.6) contrast(1.08)", transform: "scale(1.12)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(15,17,21,0.94) 0%, rgba(15,17,21,0.8) 55%, rgba(15,17,21,0.5) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "radial-gradient(120% 90% at 100% 0%, rgba(192,0,0,0.24), transparent 55%)" }} />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
        {eyebrow && <div className="text-xs font-bold tracking-[0.2em] mb-4" style={{ color: "#c00000" }}>{eyebrow}</div>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white max-w-3xl leading-[1.06]" style={O}>
          {title} {highlight && <span style={{ color: "#c00000" }}>{highlight}</span>}
        </h1>
        {subtitle && <p className="mt-6 text-base sm:text-lg text-gray-300 leading-relaxed max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}

export function CTASection({ title, text, primary, secondary }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const de = lang === "de";
  const T = title || (de ? "Bereit für volle Transparenz?" : "Ready for full transparency?");
  const TX = text || (de ? "Fordern Sie eine unverbindliche Live-Demo an – wir zeigen Ihnen FleetArea an Ihren eigenen Beispielen." : "Request a no-obligation live demo – we'll show you FleetArea with your own examples.");
  const P = primary || (de ? "Demo anfragen" : "Request demo");
  const S = secondary || (de ? "Login" : "Sign in");
  return (
    <section className="relative overflow-hidden" style={{ background: "#1B1E23" }}>
      <div aria-hidden className="absolute inset-0" style={{ background: "radial-gradient(120% 100% at 0% 100%, rgba(192,0,0,0.28), transparent 55%)" }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-white max-w-xl" style={O}>{T}</h2>
          <p className="mt-3 text-gray-300 max-w-xl leading-relaxed">{TX}</p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button data-testid="cta-primary" onClick={() => navigate("/kontakt")} className="inline-flex items-center gap-2 text-white font-bold rounded-xl px-6 py-3.5 text-sm transition-all hover:brightness-110 hover:-translate-y-0.5 shadow-lg" style={{ background: RED, boxShadow: `0 12px 34px -14px ${RED}` }}>{P} <ArrowRight className="w-4 h-4" /></button>
          <button data-testid="cta-secondary" onClick={() => navigate("/login")} className="inline-flex items-center gap-2 bg-white/10 border border-white/20 hover:bg-white/20 text-white font-semibold rounded-xl px-6 py-3.5 text-sm transition-colors">{S}</button>
        </div>
      </div>
    </section>
  );
}
